import React, { useMemo, useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  ListSubheader,
  Checkbox,
  ListItemText,
  IconButton,
  Typography,
  Divider,
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { i18n } from "../../translate/i18n";

const getQueueGroup = (name) => {
  const groups = {
    cliente: ["Sou Cliente", "Não sou Cliente"],
    produto: [
      "🚀 Aquisição de um novo produto ou oportunidades imperdíveis!",
      "Produto Hard Rock",
      "Produto Bento Gonçalves",
      "Produto Castelos Gramado",
      "Produto Terra Santa",
      "Produto Arca Parque",
    ],
    negociacao: [
      "Negociar Débitos - Hard Rock",
      "Negociar Débitos - Castelos Bento",
      "Negociar Débitos - Castelos Gramado",
      "Negociar Débitos - Terra Santa",
      "Negociar Débitos - Arca Parque",
      "Negociar Débitos - Terra Santa Monte das Oliveiras e Sinai",
      "Negociar Débitos - Terra Santa Canãa e Sião",
      "Negociar Débitos - Terra Santa Galiléia e Hermon",
      "Negociar Débitos - Conjunto Terra Santa",
      "Especialista - Hard Rock",
      "Especialista - Castelos Bento",
      "Especialista - Castelos Gramado",
      "Especialista - Terra Santa",
      "Especialista - Arca Parque",
      "Especialista - Terra Santa Monte das Oliveiras e Sinai",
      "Especialista - Terra Santa Canãa e Sião",
      "Especialista - Terra Santa Galiléia e Hermon",
      "Especialista - Conjunto Terra Santa",
      "2° segunda via de boleto 🧾",
      "Quero falar com um especialista 📞",
      "Antecipação e Quitação de Parcelas 💸",
      "Negociar débitos em aberto 📊",
      "💰 Boletos e Negociações Financeiras",
    ],
    rci: [
      "✨ Benefícios e Parcerias",
      "Beneficio ID RCI",
      "Beneficio Viagem RCI",
      "Beneficio Wine Club",
    ],
    empreendimento: [
      "Hard Rock",
      "Castelos do Vale - Bento Gonçalves",
      "Castelos Gramado",
      "Terra Santa Galiléia e Hermon",
      "Terra Santa Canãa e Sião",
      "Terra Santa Monte das Oliveiras e Sinai",
      "Conjunto Terra Santa",
    ],
    outros: [
      "Negociação",
      "Relacionamento",
      "SAC",
      "Sucesso do Cliente",
      "Arca Parque",
      "Retencao",
      "🎟️ Compra de ingressos e reservas no parque!",
      "📝 Dúvidas sobre seu contrato?",
      "🤝 Se algo não saiu como esperado, estamos aqui para resolver!",
      "📞 Falar com um atendente",
    ],
  };

  for (const [grupo, nomes] of Object.entries(groups)) {
    if (nomes.includes(name)) return grupo;
  }
  return "outros";
};

const groupLabels = {
  cliente: "Grupo Cliente",
  produto: "Grupo Produto",
  negociacao: "Grupo Negociação",
  rci: "Grupo RCI",
  empreendimento: "Grupo Empreendimento",
  outros: "Grupo Outros",
};

const TicketsQueueSelect = ({
  userQueues = [],
  selectedQueueIds = [],
  onChange,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [expandedGroups, setExpandedGroups] = useState({
    cliente: true,
    produto: true,
    negociacao: true,
    rci: true,
    empreendimento: true,
    outros: true,
  });

  const groupedQueues = useMemo(() => {
    const groups = {
      cliente: [],
      produto: [],
      negociacao: [],
      rci: [],
      empreendimento: [],
      outros: [],
    };
    userQueues.forEach((queue) => {
      const grupo = getQueueGroup(queue.name);
      groups[grupo].push(queue);
    });
    return groups;
  }, [userQueues]);

  const allQueueIds = userQueues.map((q) => q.id);
  const allSelected = allQueueIds.length === selectedQueueIds.length;

  const toggleAll = () => {
    if (allSelected) {
      onChange([]);
    } else {
      onChange(allQueueIds);
    }
  };

  const toggleGroup = (groupName) => {
    const groupIds = groupedQueues[groupName].map((q) => q.id);
    const allSelected = groupIds.every((id) => selectedQueueIds.includes(id));
    if (allSelected) {
      onChange(selectedQueueIds.filter((id) => !groupIds.includes(id)));
    } else {
      onChange([...new Set([...selectedQueueIds, ...groupIds])]);
    }
  };

  const toggleQueue = (id) => {
    if (selectedQueueIds.includes(id)) {
      onChange(selectedQueueIds.filter((q) => q !== id));
    } else {
      onChange([...selectedQueueIds, id]);
    }
  };

  return (
    <div>
      <Button variant="outlined" onClick={(e) => setAnchorEl(e.currentTarget)}>
        {i18n.t("ticketsQueueSelect.placeholder")}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ style: { maxHeight: 500, width: 320 } }}
      >
        <ListSubheader
          disableSticky
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#fff", // fundo branco sólido
            zIndex: 1,
          }}
        >
          <Typography variant="subtitle2">Filas</Typography>
          <Button
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              toggleAll();
            }}
          >
            {allSelected ? "Desmarcar todas" : "Selecionar todas"}
          </Button>
        </ListSubheader>
        <Divider />

        {Object.entries(groupedQueues).map(([groupName, queues]) => (
          <div key={groupName}>
            <ListSubheader
              disableSticky
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#fff", // fundo branco fixo
                zIndex: 1,
              }}
            >
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  toggleGroup(groupName);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  checked={queues.every((q) => selectedQueueIds.includes(q.id))}
                  style={{ padding: 0, marginRight: 8 }}
                />
                {groupLabels[groupName] || groupName}
              </div>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setExpandedGroups((prev) => ({
                    ...prev,
                    [groupName]: !prev[groupName],
                  }));
                }}
              >
                {expandedGroups[groupName] ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </ListSubheader>

            {expandedGroups[groupName] &&
              queues.map((queue) => (
                <MenuItem
                  key={queue.id}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleQueue(queue.id);
                  }}
                >
                  <Checkbox
                    checked={selectedQueueIds.includes(queue.id)}
                    icon={
                      <span
                        style={{
                          width: 18,
                          height: 18,
                          backgroundColor: "#1a1a1a",
                          borderRadius: 4,
                        }}
                      />
                    }
                    checkedIcon={
                      <span
                        style={{
                          width: 18,
                          height: 18,
                          backgroundColor: "#1a1a1a",
                          borderRadius: 4,
                          position: "relative",
                        }}
                      >
                        <svg
                          viewBox="0 0 24 24"
                          style={{
                            position: "absolute",
                            top: -3,
                            left: -2,
                            width: 24,
                            height: 24,
                            fill: "red",
                          }}
                        >
                          <path d="M9 16.2l-3.5-3.5 1.41-1.41L9 13.38l7.09-7.09L17.5 7l-8.5 8.5z" />
                        </svg>
                      </span>
                    }
                  />
                  <ListItemText primary={queue.name} />
                </MenuItem>
              ))}
          </div>
        ))}
      </Menu>
    </div>
  );
};

export default TicketsQueueSelect;
